import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Utilities
import { mapState, mapGetters } from 'vuex';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreFeedback',
  props: {
    feedbackDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    dialogTitle: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      formValid: false,
      formItem: {},
      bug: '0',
      formData: new FormData(),
      isLoading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), mapGetters({
    user: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    version: function version() {
      return this.$store.state.app.packageVersion;
    },
    // title() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.bugTitle');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.commitment');
    //     }
    //     return this.$i18n_t('Common.help.shortDescription');
    //   }
    // },
    feedback: function feedback() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.feedbackSuggestion');
      } else if (this.bug === '1') {
        return this.$i18n_t('Common.help.bugDescription');
      } else {
        return this.$i18n_t('Common.help.feedback');
      }
    },
    // description() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.howReproduce');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.needItFor');
    //     }
    //     return this.$i18n_t('Common.help.description');
    //   }
    // },
    placeholder: function placeholder() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.placeholderSuggestion');
      }

      return this.$i18n_t('Common.help.placeholder');
    },
    buttons: function buttons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.help.send'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  }),
  watch: {
    feedbackDialog: function feedbackDialog() {
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      if (this.feedbackDialog) {
        this.formItem['email'] = this.user.email;
        this.formItem['userId'] = this.user.id;
      }
    },
    createFormData: function createFormData() {
      var subject = this.formItem.title ? this.formItem.title : this.$i18n_t('Common.help.customerFeedback');
      this.formData.append('tenantId', this.tenantId);
      this.formData.append('userId', this.formItem.userId);
      this.formData.append('subject', subject);
      this.formData.append('content', this.createBody());

      if (this.bug === '1') {
        this.formData.append('bug', true);
      }

      this.send();
    },
    files: function files(_files) {
      var _this2 = this;

      this.formData = new FormData();

      if (_files.length > 1) {
        _files.forEach(function (file) {
          _this2.formData.append('attachment', file, file.name);
        });
      } else {
        this.formData.append('file', _files[0]);
      }
    },
    close: function close() {
      this.clear();
      this.$emit('close');
    },
    clear: function clear() {
      this.formItem = {};
      this.formData = new FormData();
      this.$refs.uploadMultiple.clear();
    },
    createBody: function createBody() {
      var body = "<h3>".concat(this.dialogTitle, "</h3>");

      if (this.type === 'like') {
        body += this.createDescription(this.formItem.description);
      }

      if (this.type !== 'like') {
        body += this.createDescription(this.formItem.title, this.formItem.description, this.formItem.feedback);
      }

      if (this.formItem.contact) {
        body += "<p>".concat(this.$i18n_t('Common.help.contactMe'), "</p>");
      }

      body += '<hr />';
      body += "<p>".concat(this.$i18n_t('Common.help.emailUser'), ": ").concat(this.formItem.email, "</p>");
      body += "<p>".concat(this.$i18n_t('Common.help.userId'), ": ").concat(this.formItem.userId, "</p>");
      body += "<p>".concat(this.$i18n_t('Common.help.systemVersion'), ": ").concat(this.version, "</p>");
      return body;
    },
    createDescription: function createDescription(text) {
      var text2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var text3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var content = '';

      if (text2 && text3) {
        content += "<b>".concat(this.$i18n_t('Common.help.titel'), "</b></br />");
        content += "<p>".concat(text, "</p></br>");
        content += "<b>".concat(this.$i18n_t('Common.description'), "</b></br>");
        content += "<p>".concat(text2, "</p></br>");
        content += "<b>".concat(this.$i18n_t('Common.help.detailedDescription'), "</b></br>");
        content += "<p>".concat(text3, "</p></br></br>");
      } else {
        content = "<b>".concat(this.$i18n_t('Common.description'), "</b></br>");
        content += "<p>".concat(text, "</p></br></br>");
      }

      return content;
    },
    send: function send() {
      var _this3 = this;

      this.isLoading = true;
      return ApiService.sendFeedback(this.formData).then(function () {
        _this3.$snack(_this3.$i18n_t('Common.help.feedbackSendSuccess'), 'success');

        _this3.$emit('close');

        _this3.clear();
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.help.sendingError'), 'error');
        }

        throw error;
      }).finally(function () {
        return _this3.isLoading = false;
      });
    },
    clearFiles: function clearFiles() {
      this.formData.delete('attachment');
      this.formData.delete('file');
    }
  }
};